export default {
  CREATE_ALLIANZ_POLICY_COMMAND: Symbol.for('CREATE_ALLIANZ_POLICY_COMMAND'),
  CREATE_ALLIANZ_POLICY_REPOSITORY: Symbol.for('CREATE_ALLIANZ_POLICY_REPOSITORY'),
};
